module.exports = __webpack_public_path__ + "static/media/save-icon.d8607e64.PNG";